<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-temperature`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.667 2c1.945 0 3.247 1.725 3.329 3.663l.004.194V28a9.985 9.985 0 014 8c0 5.523-4.477 10-10 10s-10-4.477-10-10a9.985 9.985 0 014-8V5.856c0-1.95 1.239-3.738 3.14-3.851L17.334 2h5.334zM22 6h-4v24.341a6 6 0 104 0l.001-4.14L22 6zm16 17a1 1 0 00-1-1h-6a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1v-2zm-1-9a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1h6zm1-7a1 1 0 00-1-1h-6a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V7z"/></svg>
</template>
<script>

export default {
  name: 'IconTemperature',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
